import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ProfileIncompleteAlert.css';

const ProfileIncompleteAlert = () => {
  const navigate = useNavigate();

  return (
    <div className="profile-incomplete-container">
      <div className="profile-incomplete-card">
        <div className="alert-icon">
          <i className="fas fa-building"></i>
        </div>

        <h2>Complete Your Company Profile</h2>
        <p>You need to create your company profile before you can post jobs or access other features.</p>

        <div className="features-list">
          <div className="feature-item">
            <i className="fas fa-check-circle"></i>
            <span>Post unlimited jobs</span>
          </div>
          <div className="feature-item">
            <i className="fas fa-check-circle"></i>
            <span>Manage applications</span>
          </div>
          <div className="feature-item">
            <i className="fas fa-check-circle"></i>
            <span>Connect with consultants</span>
          </div>
          <div className="feature-item">
            <i className="fas fa-check-circle"></i>
            <span>Access analytics</span>
          </div>
        </div>

        <button
          className="btn btn-primary btn-create-profile"
          onClick={() => navigate('/employer/company-profile')}
        >
          <i className="fas fa-plus-circle"></i>
          Create Company Profile
        </button>

        <p className="help-text">
          <i className="fas fa-info-circle"></i>
          It only takes a few minutes to set up your profile
        </p>
      </div>
    </div>
  );
};

export default ProfileIncompleteAlert;
